export default function ArzoooLogo() {
  return (
    <img
      src="https://arzooo-static-prod-v2.s3.ap-south-1.amazonaws.com/logos/arzooo.png"
      alt="arzooo"
      width={100}
    ></img>
  );
}
